import { useCallback, useMemo, useState } from "react";
import { groupByNestedProperty } from "../../../../helpers";

export const useActionSelection = () => {
  const [checkedIds, setCheckedIds] = useState([]);
  const [checkedAction, setCheckedActions] = useState([]);
  const checkedParamIds = useMemo(() => {
    if (checkedAction.length === 0) {
      return [];
    }

    return checkedAction.reduce((acc, action) => {
      const parameterId = Number(
        action?.parameter_id ?? action?.parameterId ?? action?.id
      );

      if (!Number.isFinite(parameterId) || acc.includes(parameterId)) {
        return acc;
      }

      acc.push(parameterId);
      return acc;
    }, []);
  }, [checkedAction]);

  const groupedSelectedActions = useMemo(() => {
    if (checkedAction.length === 0) {
      return null;
    }

    return groupByNestedProperty(checkedAction, "group_lexic_id");
  }, [checkedAction]);

  const handleCheckboxChange = useCallback((action, group) => {
    setCheckedIds((prevIds) => {
      if (prevIds.includes(action.id)) {
        return prevIds.filter((item) => item !== action.id);
      }

      return [...prevIds, action.id];
    });

    setCheckedActions((prev) => {
      const isSelected = prev.some((selected) => +selected?.id === +action.id);

      if (isSelected) {
        return prev.filter((selected) => +selected?.id !== +action.id);
      }

      return [
        ...prev,
        {
          ...action,
          group_title: group.title,
          group_lexic_id: group.lexic_id,
        },
      ];
    });
  }, []);

  const resetActionSelection = useCallback(() => {
    setCheckedIds([]);
    setCheckedActions([]);
  }, []);

  return {
    checkedIds,
    checkedParamIds,
    setCheckedIds,
    checkedAction,
    setCheckedActions,
    groupedSelectedActions,
    handleCheckboxChange,
    resetActionSelection,
  };
};

export default useActionSelection;
